import { XdrSearchLiveWebComponent } from './component/XdrSearhLiveWebComponent';
import { WEB_COMPONENT_XDR_SEARCH_LIVE } from '../../webcomponents.constants';

export { XdrSearchLiveWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_SEARCH_LIVE, XdrSearchLiveWebComponent);
